import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { RiMoneyRupeeCircleFill } from 'react-icons/ri';
import { IoIosCloseCircle } from 'react-icons/io';
import { useMyContext } from '../../../context/MyContext';
import { Base_Url, setPermissionApi } from '../../../config/config';
import { toast } from 'react-toastify';

const SetPermission = ({ isopen, onClose, selectedEmpForSetPermission }) => {
    const { isDarkMode } = useMyContext();
    const cus_id = localStorage.getItem("cus_id");
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem("token");

    const [permissionList, setPermissionList] = useState([
            { id: 1, name: 'Shipments', Permissions: { add: false, delete: false, edit: false, view: false } },
            { id: 2, name: 'Warehouses', Permissions: { add: false, delete: false, edit: false, view: false } },
            { id: 3, name: 'Disputs', Permissions: { add: false, delete: false, edit: false, view: false } },
            { id: 4, name: 'Payments', Permissions: { add: false, delete: false, edit: false, view: false } },
            { id: 5, name: 'Services ', Permissions: { add: false, delete: false, edit: false, view: false } },
            { id: 6, name: 'Customers', Permissions: { add: false, delete: false, edit: false, view: false } },
            { id: 7, name: 'Preship', Permissions: { add: false, delete: false, edit: false, view: false } },
            { id: 8, name: 'Reports', Permissions: { add: false, delete: false, edit: false, view: false } },
            { id: 9, name: 'Help',    Permissions: { add: false, delete: false, edit: false, view: false } },
            { id: 10, name: 'Setting', Permissions: { add: false, delete: false, edit: false, view: false } },
            { id: 11, name: 'Profile', Permissions: { add: false, delete: false, edit: false, view: false } }
        ]);


    const handlePermissionChange = (id, permissionType) => {
        setPermissionList(prevEmployees =>
            prevEmployees.map(employee =>
                employee.id === id
                    ? {
                        ...employee,
                        Permissions: {
                            ...employee.Permissions,
                            [permissionType]: !employee.Permissions[permissionType]
                        }
                    }
                    : employee
            )
        );
    };

    const savePermissions = async () => {
        try {
            const permissionsData = {
                employee_id: selectedEmpForSetPermission.employee_id,
                permission: {}
            };
            permissionList.forEach(employee => {
                permissionsData.permission[employee.name] = {
                    add: employee.Permissions.add ? "1" : "0",
                    edit: employee.Permissions.edit ? "1" : "0",
                    delete: employee.Permissions.delete ? "1" : "0",
                    view: employee.Permissions.view ? "1" : "0"
                };
            });
            setLoading(true);
            const response = await fetch(Base_Url + setPermissionApi, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    cus_id: cus_id,
                    token: token
                },
                body: JSON.stringify(permissionsData),
            });
            const data = await response.json();
            if (data.status === "SUCCESS") {
                toast.success(data.message);
                handleClose();
                setLoading(false);
            }
            else {
                toast.error(data.message);
                setLoading(false);
            }
        } catch (error) {
            console.error("Error saving permissions:", error);
            setLoading(false);
        }
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            open={isopen}
            onClose={onClose}
            maxWidth="lg"
            sx={{
                '& .MuiDialog-paper': {
                    width: '80%',
                    height: '80vh',
                }
            }}
        >
            <DialogTitle className="bg-customPurple text-white text-center">
                <h2 className="text-2xl font-semibold flex items-center justify-center">
                    <RiMoneyRupeeCircleFill />
                    Set Permissions
                </h2>
                <IoIosCloseCircle
                    className="absolute top-2 right-2 cursor-pointer"
                    size={32}
                    onClick={handleClose}
                />
            </DialogTitle>
            <DialogContent
                className={`shadow-custom-light rounded-custom dark:shadow-custom-dark mt-4 ml-2 mr-2 mb-4 p-4 
                  ${isDarkMode ? "dark:bg-darkmodeColor text-white" : ""}`}
                sx={{ overflowY: 'auto' }}
            >
                <div className="max-w-6xl mx-auto h-full flex flex-col">
                    {/* {showSuccess && (
                        <div className="fixed top-4 right-4 bg-gradient-to-r from-emerald-500 to-green-500 text-white p-4 rounded-lg shadow-md z-50 animate-bounce">
                            <div className="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                                Permissions saved successfully!
                            </div>
                        </div>
                    )} */}

                   {/* <div className="bg-white dark:bg-[#0c1a56] dark:text-white shadow-lg rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 flex flex-col h-full"> */}
                        <div className="p-6 flex-1 flex flex-col overflow-hidden">
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-xl font-bold text-slate-800 dark:text-white flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 text-indigo-600 dark:text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                    Role Permissions
                                </h2>
                            </div>


                            <div className="flex items-center justify-between mb-3 px-1">
                                <div className="flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-slate-500 dark:text-slate-400 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                    </svg>
                                    <span className="text-sm font-medium text-slate-700 dark:text-slate-300">Module Permissions</span>
                                </div>
                                <div className="text-xs text-slate-500 dark:text-slate-400 flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                                    </svg>
                                    {permissionList.length} modules
                                </div>
                            </div>

                            <div className="flex-1 overflow-y-auto custom-scrollbar rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm relative">
                                <div className="sticky top-0 z-10 w-full">
                                    <div className="bg-gradient-to-r from-slate-50 to-indigo-50 dark:from-slate-800 dark:to-indigo-900 border-b border-slate-200 dark:border-slate-700">
                                        <div className="grid grid-cols-5 text-left">
                                            <div className="py-3 px-4 text-left font-medium text-slate-700 dark:text-slate-300 text-sm">Module</div>
                                            <div className="py-3 px-2 text-center font-medium text-green-600 dark:text-green-500 text-xs flex flex-col items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                </svg>
                                                <span>Add</span>
                                            </div>
                                            <div className="py-3 px-2 text-center font-medium text-red-600 dark:text-red-500 text-xs flex flex-col items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                                <span>Delete</span>
                                            </div>
                                            <div className="py-3 px-2 text-center font-medium text-blue-600 dark:text-blue-500 text-xs flex flex-col items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                </svg>
                                                <span>Edit</span>
                                            </div>
                                            <div className="py-3 px-2 text-center font-medium text-purple-600 dark:text-purple-500 text-xs flex flex-col items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                </svg>
                                                <span>View</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="overflow-hidden custom-scrollbar">
                                    {permissionList.length > 0 ? (
                                        permissionList.map((employee, index) => (
                                            <div
                                                key={employee.id}
                                                className={`grid grid-cols-5 text-left hover:bg-indigo-50 dark:hover:bg-indigo-900/30 transition-colors duration-150 ${index % 2 === 0 ? 'bg-white dark:bg-slate-800' : 'bg-slate-50 dark:bg-slate-800/70'}`}
                                            >
                                                <div className="py-3 px-4 border-b border-slate-200 dark:border-slate-700 flex items-center">
                                                    <div className="font-medium text-slate-800 dark:text-slate-200 text-sm">{employee.name}</div>
                                                </div>
                                                <div className="py-3 px-2 border-b border-slate-200 dark:border-slate-700 text-center">
                                                    <label className="inline-flex items-center justify-center">
                                                        <input
                                                            type="checkbox"
                                                            className="h-4 w-4 text-green-600 border-2 border-slate-300 dark:border-slate-600 rounded transition-all duration-150 focus:ring-2 focus:ring-offset-0 focus:ring-green-500 focus:ring-opacity-50"
                                                            checked={employee.Permissions.add}
                                                            onChange={() => handlePermissionChange(employee.id, 'add')}
                                                        />
                                                        <span className="sr-only">Add permission</span>
                                                    </label>
                                                </div>
                                                <div className="py-3 px-2 border-b border-slate-200 dark:border-slate-700 text-center">
                                                    <label className="inline-flex items-center justify-center">
                                                        <input
                                                            type="checkbox"
                                                            className="h-4 w-4 text-red-600 border-2 border-slate-300 dark:border-slate-600 rounded transition-all duration-150 focus:ring-2 focus:ring-offset-0 focus:ring-red-500 focus:ring-opacity-50"
                                                            checked={employee.Permissions.delete}
                                                            onChange={() => handlePermissionChange(employee.id, 'delete')}
                                                        />
                                                        <span className="sr-only">Delete permission</span>
                                                    </label>
                                                </div>
                                                <div className="py-3 px-2 border-b border-slate-200 dark:border-slate-700 text-center">
                                                    <label className="inline-flex items-center justify-center">
                                                        <input
                                                            type="checkbox"
                                                            className="h-4 w-4 text-blue-600 border-2 border-slate-300 dark:border-slate-600 rounded transition-all duration-150 focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 focus:ring-opacity-50"
                                                            checked={employee.Permissions.edit}
                                                            onChange={() => handlePermissionChange(employee.id, 'edit')}
                                                        />
                                                        <span className="sr-only">Edit permission</span>
                                                    </label>
                                                </div>
                                                <div className="py-3 px-2 border-b border-slate-200 dark:border-slate-700 text-center">
                                                    <label className="inline-flex items-center justify-center">
                                                        <input
                                                            type="checkbox"
                                                            className="h-4 w-4 text-purple-600 border-2 border-slate-300 dark:border-slate-600 rounded transition-all duration-150 focus:ring-2 focus:ring-offset-0 focus:ring-purple-500 focus:ring-opacity-50"
                                                            checked={employee.Permissions.view}
                                                            onChange={() => handlePermissionChange(employee.id, 'view')}
                                                        />
                                                        <span className="sr-only">View permission</span>
                                                    </label>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="py-12 text-center text-slate-500 dark:text-slate-400 text-sm flex flex-col items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mb-3 text-slate-300 dark:text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            <p>No modules found matching your search criteria.</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="mt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
                                <div className="text-xs text-slate-500 dark:text-slate-400 flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <p>Last updated: April 1, 2025</p>
                                </div>
                                <div className="flex gap-3">
                                    <button
                                        className="px-4 py-2 bg-white text-slate-700 dark:bg-slate-800 dark:text-slate-200 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-opacity-50 transition-all duration-150 font-medium text-sm shadow-sm border border-slate-200 dark:border-slate-700"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="px-4 py-2 bg-gradient-to-r from-indigo-600 to-violet-600 text-white rounded-lg hover:from-indigo-700 hover:to-violet-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 transition-all duration-150 shadow-sm hover:shadow-md font-medium text-sm flex items-center"
                                        onClick={savePermissions}
                                        disabled={loading}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                                        </svg>

                                        {loading ? 'Saving...' : 'Save Permissions'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    {/* </div> */}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default SetPermission;
